import React from 'react';
import { ScrollText } from '..';
import { Container, Title } from '../styled/styled';

import logoBg from '../../image/logo-bg.svg';
import styled from 'styled-components';

const HomeStyled = styled.div`
  margin-top: -90px;
  height: 100vh;
  display: flex;
  align-items: center;

  h1 {
    font-style: normal !important;
    font-weight: 400 !important;
    font-size: 78px !important;
    line-height: 92px !important;
    text-align: center !important;
  }

  @media (max-width: 1500px) {
    h1 {
      font-size: 68px !important;
      line-height: 72px !important;
    }
  }

  @media (max-width: 992px) {
    h1 {
      font-size: 30px !important;
      line-height: 35px !important;
    }
  }
  @media (max-width: 660px) {
    h1 {
      font-size: 20px !important;
      line-height: 30px !important;
    }
  }

  @media (max-height: 660px) {
    h1 {
      font-size: 40px !important;
      line-height: 50px !important;
    }
  }
  @media (max-height: 560px) {
    h1 {
      font-size: 30px !important;
      line-height: 30px !important;
    }
  }
  @media (max-height: 460px) {
    margin-top: -50px;
  }
`;
const HomeContent = styled.div`
  margin-top: 80px;
  @media (max-width: 1920px) {
    margin-top: 50px;
  }

  @media (max-width: 992px) {
    margin-top: 100px;
  }
  @media (max-height: 660px) {
    margin-top: 20px;
  }
`;

const HomeLogo = styled.img`
  max-width: 100%;
  width: 100%;
  margin: 0px auto;
  margin-top: 50px;

  @media (max-width: 1920px) {
    margin-top: 40px;
  }

  @media (max-width: 992px) {
    margin-top: 100px;
  }

  @media (max-height: 660px) {
    margin-top: 10px;
  }
  @media (max-height: 560px) {
    max-width: 50% !important;
    margin-top: 0px;
  }
`;

export const Home = () => {
  return (
    <HomeStyled id="home">
      <Container>
        <HomeLogo className="logo" src={logoBg} alt="" />
        <HomeContent>
          <h1>We are a young team engaged in the development of full-stack IT projects.</h1>
          <ScrollText>SCROLL DOWN TO GET MORE INFORMATION ABOUT US</ScrollText>
        </HomeContent>
      </Container>
    </HomeStyled>
  );
};
